import { AppConfig } from '../app/helpers/config';
import { commonConfig, releaseNotesConfig } from './base';

export const environment: AppConfig = Object.assign({}, commonConfig, releaseNotesConfig, {
    apiUrl: 'https://releasenotes-cloudrun-wfh4cbpmxq-ew.a.run.app/',
    production: true,
});
